import ProductGeneral from "./../../../../components/catalog/product/edit/general";
import Service from "./../../../../utils/api/service";
import ListVaraintOption from "../../../../components/catalog/product/edit/variant";

export default {
  name: "EditProduct",
  data() {
    return {
      data: {
        productDetail: "",
        categories: [],
        productGeneral: "",
      },
      isLoading: false,
      display: {
        tab: "general",
      },
      // define the default value
      value: null,
      options: [],
      branchId:
        this.$route.query.branchId ||
        (this.$store?.state?.accountInfo?.branches &&
          this.$store?.state?.accountInfo?.branches[0]?.id) ||
        "",
      branches: this.$store?.state?.accountInfo?.branches,
    };
  },
  components: {
    ProductGeneral,
    ListVaraintOption,
  },
  created() {
    this.getProductDetail(this.$route.query.id, this.$route.query.branchId);
  },
  methods: {
    async getProductDetail(id, branchId) {
      this.isLoading = true;
      await this.$router
        .push({ query: { id: id, branchId: branchId } })
        .catch(() => {});

      await Service.getProductDetail(`${id}?branchId=${branchId}`).then(
        (response) => {
          this.isLoading = false;
          if (response.statusCode) {
            if (response.statusCode == "4410") {
              Service.refreshToken().then((response) => {
                if (response == "ok") {
                  this.getProductDetail(`${id}?branchId=${branchId}`);
                }
              });
            } else {
              this.$toasted.show(response.message);
            }
          } else {
            this.data.productDetail = response.data;
          }
        }
      );
    },

    changeTab(type) {
      this.display.tab = type;
    },

    createProductGeneralListener(productGeneral) {
      this.data.productGeneral = productGeneral;
    },
  },
};
